import React from 'react';
import clsx from 'clsx';

import { BaseComponentProps } from '@utils/types/baseComponents';

import styles from './styles.module.scss';

type Props = {
  isSelected: boolean;
  onClick: () => void;
  children: JSX.Element | string;
} & BaseComponentProps;

RadioChoice.defaultProps = {
  value: false,
  onChange: () => {},
};

export function RadioChoice(props: Props) {
  const { containerStyle, isSelected, onClick, children, theme } = props;

  return (
    <div
      className={clsx([styles.radioChoice, containerStyle])}
      onClick={onClick}
    >
      <div
        className={clsx([
          styles.radio,
          theme === 'dark' && styles.dark,
          isSelected && styles.active,
        ])}
      />
      {children}
    </div>
  );
}
